import IconChatty from '@assets/components/ResouceIcon/IconChatty';
import IconQuestion from '@assets/components/ResouceIcon/IconQuestion';
import IconComment from '@assets/components/ResouceIcon/IconComment';
import IconIdea from '@assets/components/ResouceIcon/IconIdea';
import IconFloatMessage from '@assets/components/ResouceIcon/IconFloatMessage';
import IconFloatPhoneCall from '@assets/components/ResouceIcon/IconFloatPhoneCall';
import IconFloatMessenger from '@assets/components/ResouceIcon/IconFloatMessenger';
import IconFloatTelegram from '@assets/components/ResouceIcon/IconFloatTelegram';
import {
  ICON_FLOAT_CHATTY,
  ICON_FLOAT_COMMENT,
  ICON_FLOAT_IDEA,
  ICON_FLOAT_MESSAGE,
  ICON_FLOAT_MESSENGER,
  ICON_FLOAT_PHONE_CALL,
  ICON_FLOAT_QUESTION,
  ICON_FLOAT_TELEGRAM
} from '@functions/const/floatWidgetButton';

export const iconArray = [
  {key: ICON_FLOAT_CHATTY, Icon: IconChatty},
  {key: ICON_FLOAT_QUESTION, Icon: IconQuestion},
  {key: ICON_FLOAT_COMMENT, Icon: IconComment},
  {key: ICON_FLOAT_IDEA, Icon: IconIdea},
  {key: ICON_FLOAT_MESSAGE, Icon: IconFloatMessage},
  {key: ICON_FLOAT_PHONE_CALL, Icon: IconFloatPhoneCall},
  {key: ICON_FLOAT_MESSENGER, Icon: IconFloatMessenger},
  {key: ICON_FLOAT_TELEGRAM, Icon: IconFloatTelegram}
];
